import { keys } from 'app/config/keys';

export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GOOGLE_ANALYTICS_KEY: keys.GOOGLE_ANALYTICS_KEY,
};
